import { gql } from '@apollo/client/core';
import { useMutation } from '@apollo/client/react/hooks/useMutation';
import { updateHandlerByName } from '../graphql';
import {
	MutationDeleteItemSubcategoryArgs,
	Mutation,
} from '../typings/graphql';

const MUTATION = gql`
	mutation deleteItemSubcategory($id: ID!) {
		deleteItemSubcategory(id: $id) {
			id
			name
		}
	}
`;

export default (): ((
	variables: MutationDeleteItemSubcategoryArgs
) => Promise<void>) => {
	const [deleteItemSubcategory] = useMutation<
		Pick<Mutation, 'deleteItemSubcategory'>,
		MutationDeleteItemSubcategoryArgs
	>(MUTATION, {
		context: {
			serializationKey: 'MUTATION',
			tracked: true,
		},

		update: updateHandlerByName.deleteItemSubcategory,
	});

	return async (variables: { id: string }): Promise<void> => {
		try {
			await deleteItemSubcategory({
				variables,
			});
		} catch (error) {
			console.log('err', error);
		}
	};
};
